import React from 'react';

import { useIntl, type MessageDescriptor } from 'react-intl';

import { Image } from '@/libraries/design/components/image/src/image';
import { messages } from '@/templates/ondemand/signup/confirmation/confirmation-page/src/views/coding-agent-choice/messages';
import {
	CODING_AGENT_IDS,
	type CodingAgentId,
} from '@/templates/ondemand/signup/confirmation/confirmation-page/src/views/coding-agent-choice/types';

import claudeLogo from './assets/claude.png';
import codexLogo from './assets/codex.png';
import copilotLogo from './assets/copilot.png';
import cursorLogo from './assets/cursor.png';

const AGENT_LOGO: Record<CodingAgentId, string> = {
	[CODING_AGENT_IDS.githubCopilot]: copilotLogo,
	[CODING_AGENT_IDS.claude]: claudeLogo,
	[CODING_AGENT_IDS.cursor]: cursorLogo,
	[CODING_AGENT_IDS.codex]: codexLogo,
};

const AGENT_ALT_MESSAGE: Record<CodingAgentId, MessageDescriptor> = {
	[CODING_AGENT_IDS.githubCopilot]: messages.githubCopilotLogoAlt,
	[CODING_AGENT_IDS.claude]: messages.claudeLogoAlt,
	[CODING_AGENT_IDS.cursor]: messages.cursorLogoAlt,
	[CODING_AGENT_IDS.codex]: messages.codexLogoAlt,
};

export interface JfindAgentAvatarProps {
	readonly agentId: CodingAgentId;
	readonly size?: number;
}

export const JfindAgentAvatar: React.FC<JfindAgentAvatarProps> = ({ agentId, size = 24 }) => {
	const intl = useIntl();

	return (
		<Image
			src={AGENT_LOGO[agentId]}
			alt={intl.formatMessage(AGENT_ALT_MESSAGE[agentId])}
			width={size}
			style={{ flexShrink: 0 }}
		/>
	);
};
